<template>
  <div class="ui middle center aligned grid" id="login">
    <div class="column">
      <h2 class="ui teal image header">
        <div class="content">
          用户登录
        </div>
      </h2>
      <div class="ui warning message" v-if="$route.query.redirect">
        需要登录后才能访问
      </div>
      <form id='login-form' class="ui large form">
        <div class="ui stacked segment">
          <div class="field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input type="text" name="username" v-model="creds.username" placeholder="Username">
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input type="password" name="password" v-model="creds.password" placeholder="Password">
            </div>
          </div>
          <div class="ui fluid large teal submit button">登录</div>
          <div class="ui error message">
          </div>
        </div>
      </form>
      <div class="extra content">
        <div class="weibo" v-show="weiboUrl">
          <a :href="weiboUrl" rel="external nofollow" >
            微博登录
            <i class="weibo icon"></i>
          </a>
        </div>
      </div>
      <div class="extra content">
        没有帐号？
        <router-link to="/register">注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../services/Auth'
  import storage from '../../services/StorageService'
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    name: 'login-view',
    data () {
      return {
        weiboUrl: '',
        creds: {
          username: storage.getItem('username'),
          password: '',
          rememberMe: true,
        }
      }
    },
    mounted () {
      //this.load()
      $('#login-form')
      .form({
        fields: {
          username: 'empty',
          password: 'minLength[6]'
        },
        onSuccess: this.login
      })
    },
    methods: {
      load() {
        axios.get('/oauth/weibo/link').then(({data}) => {
          this.weiboUrl = data
        })
      },
      login () {
        storage.removeItem('access_token')
        auth.login(this.creds, success => {
          if (!success) {
            $('#login-form').form('add errors', {password: '登录失败'})
            $('#login-form').form('add prompt', 'password')
            storage.removeItem('username')
            this.creds.password = ''
          } else {
            storage.setItem('username', this.creds.username)
            this.creds.username = ''
            this.creds.password = ''
            this.$router.replace(this.$route.query.redirect || this.$route.query.return || '/')
          }
        })
        return false
      }
    }
  }
</script>

<style>
  .column {
    max-width: 465px;
  }

  #login {
    margin-top: 200px;
  }

  .weibo {
    margin-top: 12px;
    margin-bottom: 6px;
  }
</style>
